const anchors = [
  { id: 'today', name: '今日热瓜' },
  { id: 'fresh', name: '今日新瓜' },
  { id: 'scene', name: '现场速递' },
  { id: 'special', name: '必看专题' },
  { id: 'about', name: '瓜友口碑' },
  { id: 'faq', name: '常见问题' },
];

const areas = ['望京新店', '三里屯现场', '国贸商圈', '朝阳公园', '双井社区', '亮马河夜场'];

function scrollTo(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <>
      <section id="contact" className="scroll-mt-24 py-10 md:py-14">
        <div className="chigua-container">
          <div className="grid grid-cols-1 items-center gap-6 overflow-hidden rounded-2xl bg-gradient-to-br from-orange-500 to-red-600 p-6 text-white md:p-8 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-3 py-1 text-xs font-bold backdrop-blur-sm">
                <i className="ri-megaphone-fill"></i>
                瓜友征集 · 商务合作
              </span>
              <h2 className="mt-3 text-2xl font-black leading-snug md:text-3xl">有线索、有猛料、想合作？</h2>
              <p className="mt-2 max-w-md text-sm leading-relaxed text-white/85">
                投稿请注明时间、地点与大致经过；商务洽谈请说明来意。我们的观察员看到邮件会尽快回复，线索核实后第一时间安排现场跟进。
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-3">
                <a
                  href="mailto:hi@chaoyangchigua.com"
                  className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-orange-700 transition-transform hover:-translate-y-0.5 cursor-pointer"
                >
                  <i className="ri-mail-send-line"></i>
                  hi@chaoyangchigua.com
                </a>
                <span className="inline-flex items-center gap-1.5 text-xs text-white/80">
                  <i className="ri-time-line"></i>
                  工作日 9:00–19:00 在线
                </span>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {areas.map((a, i) => (
                <button
                  key={a}
                  type="button"
                  onClick={() => scrollTo('fresh')}
                  className="group flex items-center gap-2 rounded-xl bg-white/10 px-4 py-3 text-sm font-medium text-left text-white/90 backdrop-blur-sm transition-colors hover:bg-white/20 cursor-pointer"
                >
                  <i className={`${['ri-fire-line', 'ri-map-pin-line', 'ri-building-line', 'ri-tree-line', 'ri-home-smile-line', 'ri-moon-line'][i]} text-orange-300`}></i>
                  {a}
                  <i className="ri-arrow-right-up-line ml-auto text-white/40 transition-transform group-hover:translate-x-0.5"></i>
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-[#2a1a10] text-amber-50/80">
        <div className="chigua-container grid grid-cols-1 gap-8 py-10 md:grid-cols-4 md:py-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-red-600 text-lg font-black text-white">瓜</span>
              <div className="leading-none">
                <p className="text-lg font-black text-white">朝阳吃瓜</p>
                <p className="mt-1 text-[11px] text-amber-200/70">瓜要趁热吃 · 料要现场挖</p>
              </div>
            </div>
            <p className="mt-4 max-w-md text-[13px] leading-relaxed text-amber-50/65">
              聚焦北京朝阳及周边片区的本地热闻与现场见闻。朝阳吃瓜把今日新瓜、最新爆料与现场速递集中呈现，面向本地吃瓜群众提供新鲜、直观、贴近现场的资讯阅读体验。
            </p>
            <div className="mt-4 flex items-center gap-3 text-xs text-amber-50/50">
              <span className="inline-flex items-center gap-1"><i className="ri-quill-pen-line"></i>真实记录，先去现场</span>
              <span className="inline-flex items-center gap-1"><i className="ri-shield-user-line"></i>涉及隐私主动脱敏</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-white">站点导航</h3>
            <ul className="mt-3 space-y-2">
              {anchors.map((a) => (
                <li key={a.id}>
                  <button type="button" onClick={() => scrollTo(a.id)} className="text-[13px] text-amber-50/70 transition-colors hover:text-amber-300 cursor-pointer">
                    {a.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-white">联系我们</h3>
            <ul className="mt-3 space-y-2 text-[13px] text-amber-50/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-amber-300"></i>
                <a href="mailto:hi@chaoyangchigua.com" className="hover:text-amber-300">hi@chaoyangchigua.com</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-amber-300"></i>
                北京 · 朝阳区（线上资讯）
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-amber-300"></i>
                工作日 9:00–19:00
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="chigua-container flex flex-col items-center justify-between gap-2 py-4 text-xs text-amber-50/45 sm:flex-row">
            <p>© {year} 朝阳吃瓜 · 本地吃瓜群众线上聚集地，本站内容仅供信息浏览。</p>
            <p className="flex items-center gap-1">
              尊重事实，理性吃瓜
              <i className="ri-heart-3-fill text-red-400"></i>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}